import { useMutationWithErrorModal } from '../useMutationWithErrorModal'
import { useSubjectLineOptions } from './SubjectLineOptionsProvider'

interface Props {
  onCancel?: () => void
}

export const useGenerateSubjectLineOptions = ({ onCancel }: Props) => {
  const { generateSubjectLineOptions } = useSubjectLineOptions()

  return useMutationWithErrorModal(generateSubjectLineOptions, { onCancel })
}
